// NOTE: This file is consumed as a *data* module (see MarketingPage.tsx,
// MarketingTemplatePage.tsx, MarketingBulkRunPage.tsx, ProjectModal.tsx),
// which all expect a default export shaped like the sibling
// `salesTemplatesData.tsx` / `hrTemplatesData.tsx` files: { workflows, templates }.
//
// This file previously contained an unrelated, unused copy of the
// `MarketingTemplate` React component (never imported from this path — the
// app actually uses src/app/modules/apps/user-management/pages/marketing/MarketingTemplate.tsx),
// which is why the build failed with "does not contain a default export".
//
// No marketing-specific template data (axiosURL/requiredQuestions/etc., the
// business content) exists anywhere in the repo to restore here, so this is a
// placeholder empty data set. The Marketing section of the new-design UI will
// render with no templates until real content is authored for this file,
// following the pattern in salesTemplatesData.tsx / hrTemplatesData.tsx.
const marketingTemplatesData = {
  workflows: [],
  templates: [],
}

export default marketingTemplatesData
